import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import AllOtherServesList from "./AllOtherServesList";

export default function SearchOtherServices() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useState(() => {
    const savedParams = sessionStorage.getItem("searchOtherParams");
    return savedParams ? JSON.parse(savedParams) : null;
  });
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
    watch,
    reset,
    setValue,
  } = useForm({
    defaultValues: searchParams || {},
  });

  useEffect(() => {
    if (searchParams) {
      sessionStorage.setItem("searchOtherParams", JSON.stringify(searchParams));
    }
  }, [searchParams]);

  // Watch all fields for changes
  const watchedFields = watch();

  useEffect(() => {
    if (errors.form) {
      clearErrors("form");
    }
  }, [watchedFields, errors.form, clearErrors]);

  const onSubmit = (formData) => {
    const hasValue = Object.values(formData).some((val) => val.trim() !== "");
    if (!hasValue) {
      setError("form", {
        type: "manual",
        message: "At least one field is required.",
      });
      toast.warning("Please fill at least one field.");
      return;
    }

    setSearchParams(formData); // ✅ Save input correctly
    sessionStorage.setItem("searchOtherParams", JSON.stringify(formData));
    clearErrors("form");
  };

  // ✅ Fix issue: Preserve user input while allowing phone_number from location
  // useEffect(() => {
  //   if (location?.state && !watchedFields.phone_number) {
  //     setValue("phone_number", location.state);
  //     setSearchParams((prevParams) => ({
  //       ...prevParams,
  //       phone_number: location.state,
  //     }));
  //   }
  // }, [location?.state, setValue, watchedFields.phone_number]);

  useEffect(() => {
    if (location?.state) {
      const newParams = { phone_number: location.state }; // Only store phone_number
      setSearchParams(newParams);
      sessionStorage.setItem("searchOtherParams", JSON.stringify(newParams));

      // Update form field
      reset(newParams);
    }
  }, [location?.state, reset]);

  return (
    <div className="bg-gray-900 py-6 text-white sm:mx-4">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid gap-6 pb-4 sm:pb-0"
      >
        {/* Input Fields */}
        <div className="mx-2 grid grid-cols-1 items-end gap-4 sm:grid-cols-2 md:grid-cols-4">
          <div>
            <label
              htmlFor="email"
              className="mb-2 block text-sm font-medium text-white"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter email"
              className="w-full rounded border border-gray-300 bg-white p-2 text-gray-800"
              {...register("email")}
            />
          </div>
          <div>
            <label
              htmlFor="phone_number"
              className="mb-2 block text-sm font-medium text-white"
            >
              Phone Number
            </label>
            <input
              type="text"
              id="phone_number"
              placeholder="Enter phone number"
              className="w-full rounded border border-gray-300 bg-white p-2 text-gray-800"
              {...register("phone_number")}
            />
          </div>
          <div>
            <label
              htmlFor="booking_reference"
              className="mb-2 block text-sm font-medium text-white"
            >
              Booking Reference
            </label>
            <input
              type="text"
              id="booking_reference"
              placeholder="Enter booking reference"
              className="w-full rounded border border-gray-300 bg-white p-2 text-gray-800"
              {...register("booking_reference")}
            />
          </div>
          {/* <div>
            <label
              htmlFor="invoice_number"
              className="mb-2 block text-sm font-medium text-white"
            >
              Invoice Number
            </label>
            <input
              type="text"
              id="invoice_number"
              placeholder="Enter invoice number"
              className="w-full rounded border border-gray-300 bg-white p-2 text-gray-800"
              {...register("invoice_number")}
            />
          </div> */}
          <div className="flex flex-col">
            {searchParams && (
              <button
                type="button"
                className="mb-2 w-full rounded bg-red-500 px-4 py-2 text-white hover:bg-red-600"
                onClick={() => {
                  setSearchParams(null);
                  sessionStorage.removeItem("searchOtherParams");
                  reset({
                    // Explicitly reset form fields
                    email: "",
                    phone_number: "",
                    booking_reference: "",
                    invoice_number: "",
                  }); // ✅ Fully reset the form
                }}
              >
                Cancel
              </button>
            )}
            <button
              type="submit"
              className="w-full rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
            >
              Search Enquiry
            </button>
          </div>
        </div>

        {errors.form && (
          <p className="mt-2 text-sm text-red-500">{errors.form.message}</p>
        )}
      </form>

      {searchParams && (
        <AllOtherServesList
          key={JSON.stringify(searchParams)}
          searchComponentParams={searchParams}
        />
      )}
    </div>
  );
}
